export enum LeaveYearRulesMode {
	Add = 1,
	Edit = 2
}